// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]7.1.1-11962(b7549c6498)-C13/01/2026-17:19:05-B13/01/2026-17:26:16' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]7.1.1-11962(b7549c6498)-C13/01/2026-17:19:05-B13/01/2026-17:26:16",
  branch: "production",
  latestTag: "7.1.1",
  revCount: "11962",
  shortHash: "b7549c6498",
  longHash: "b7549c6498be4cc64fc7e1f5127ae7eaeb93c943",
  dateCommit: "13/01/2026-17:19:05",
  dateBuild: "13/01/2026-17:26:16",
  buildType: "Ansible",
  } ;
